<template>
  <div class="space-y-2">
    <p v-if="!changedKeys.length" class="text-xs text-dashboard-muted italic">
      Pas de différences détectées entre avant et après.
    </p>
    <div
      v-for="key in changedKeys"
      :key="key"
      class="bg-white border border-dashboard-border rounded-md overflow-hidden"
    >
      <div class="px-3 py-1.5 bg-dashboard-bg border-b border-dashboard-border">
        <span class="font-mono text-xs font-semibold text-dashboard-text">{{ key }}</span>
      </div>
      <div class="divide-y divide-dashboard-border">
        <div class="px-3 py-2 flex gap-2 text-xs">
          <span class="font-medium text-red-700 uppercase tracking-wide">avant</span>
          <code class="font-mono text-dashboard-text break-all flex-1">{{ formatValue(before[key]) }}</code>
        </div>
        <div class="px-3 py-2 flex gap-2 text-xs">
          <span class="font-medium text-emerald-700 uppercase tracking-wide">après</span>
          <code class="font-mono text-dashboard-text break-all flex-1">{{ formatValue(after[key]) }}</code>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  before: Record<string, any>
  after: Record<string, any>
}>()

const changedKeys = computed(() => {
  const keys = new Set([...Object.keys(props.before), ...Object.keys(props.after)])
  const diff: string[] = []
  for (const k of keys) {
    if (JSON.stringify(props.before[k]) !== JSON.stringify(props.after[k])) {
      diff.push(k)
    }
  }
  return diff.sort()
})

function formatValue(v: any): string {
  if (v === undefined || v === null) return '—'
  if (typeof v === 'object') return JSON.stringify(v)
  return String(v)
}
</script>
